import { api, apiDelete, apiPost } from "@/shared/api/http";

import type { AdminUsersPage, UserStatus } from "./types";

export interface ListUsersParams {
  status?: UserStatus;
  q?: string;
  limit?: number;
  offset?: number;
}

export const listUsers = (params: ListUsersParams = {}) => {
  const qs = new URLSearchParams();
  if (params.status && params.status !== "all") qs.set("status", params.status);
  if (params.q) qs.set("q", params.q);
  qs.set("limit", String(params.limit ?? 50));
  qs.set("offset", String(params.offset ?? 0));
  return api<AdminUsersPage>(`/api/admin/users?${qs.toString()}`);
};

export const approveUser = (id: string) =>
  apiPost<{ ok: boolean }>(`/api/admin/users/${id}/approve`, {});

export const blockUser = (id: string) =>
  apiPost<{ ok: boolean }>(`/api/admin/users/${id}/block`, {});

export const unblockUser = (id: string) =>
  apiPost<{ ok: boolean }>(`/api/admin/users/${id}/unblock`, {});

export const makeAdmin = (id: string) =>
  apiPost<{ ok: boolean }>(`/api/admin/users/${id}/make-admin`, {});

export const revokeAdmin = (id: string) =>
  apiPost<{ ok: boolean }>(`/api/admin/users/${id}/revoke-admin`, {});

export const deleteUser = (id: string) =>
  apiDelete<{ ok: boolean }>(`/api/admin/users/${id}`);
